module.exports = __webpack_public_path__ + "img/ios-teacher.6191cd2f.png";